module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_stay-d2de1930178fe586bf8b874512d24c07.jpg";